import { render, staticRenderFns } from "./TipoSolicitacaoItemEditar.vue?vue&type=template&id=31add422&"
import script from "./TipoSolicitacaoItemEditar.vue?vue&type=script&lang=js&"
export * from "./TipoSolicitacaoItemEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports